import type { TFunction } from 'i18next';
import { useMemo } from 'react';

export function useSecurityQuestions(t: TFunction) {
    const securityQuestions = useMemo(() => {
        return [
            t('security_questions.question1Text'),
            t('security_questions.question2Text'),
            t('security_questions.question3Text'),
            t('security_questions.question4Text'),
            t('security_questions.question5Text'),
            t('security_questions.question6Text'),
            t('security_questions.question7Text'),
        ];
    }, [t]);

    return { securityQuestions };
}
